import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';

export interface ClimateOption {
  climateType: string;
  cultivationCount: number;
}

export interface ClimateGroup {
  key: string;
  emoji: string;
  climates: ClimateOption[];
}

const FAMILY_LABELS: Record<string, { emoji: string; label: string }> = {
  A: { emoji: '🌴', label: 'Tropical' },
  B: { emoji: '☀️', label: 'Aride' },
  C: { emoji: '🌤', label: 'Tempéré' },
  D: { emoji: '❄️', label: 'Continental' },
  E: { emoji: '🏔', label: 'Polaire' },
};

@Component({
  selector: 'vw-climate-picker-toast',
  standalone: true,
  imports: [CommonModule, SharedModule, TranslatePipe],
  templateUrl: './climate-picker-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './climate-picker-toast.component.scss'
})
export class ClimatePickerToastComponent extends BaseToastComponent implements OnChanges {
  @Input() availableClimates: ClimateOption[] = [];
  @Input() selectedClimateType: string | null = null;
  @Input() myClimateType: string | null = null;
  @Output() climateSelected = new EventEmitter<string | null>();
  @Output() infoClick = new EventEmitter<void>();

  groups: ClimateGroup[] = [];

  constructor() {
    super();
  }

  ngOnChanges() {
    this.buildGroups();
  }

  buildGroups() {
    const map = new Map<string, ClimateOption[]>();
    for (const c of this.availableClimates) {
      const family = c.climateType[0].toUpperCase();
      if (!map.has(family)) map.set(family, []);
      map.get(family).push(c);
    }
    this.groups = Array.from(map.entries()).map(([key, climates]) => ({
      key,
      emoji: FAMILY_LABELS[key]?.emoji ?? '🌍',
      climates,
    }));
  }

  selectClimate(type: string | null) {
    this.climateSelected.emit(type);
    this.onClose();
  }

  getFamilyLabel(key: string): string {
    return FAMILY_LABELS[key]?.label ?? key;
  }
}
